var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown" }, [
    _c("span", {
      staticClass: "btn dropdown-toggle",
      attrs: { role: "button" },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          $event.stopPropagation()
          return _vm.toggleDropdown($event)
        }
      }
    }),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              class: [_vm.canClickInfo ? "" : "disabled"],
              attrs: { href: "#" },
              on: { click: _vm.infoClick }
            },
            [
              _c("i", { staticClass: "fas fa-info-circle" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource(
                      "JourneyBuilder_JourneyBrickMenu_Info_DisplayName"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              class: [_vm.canClickAddConnection ? "" : "disabled"],
              attrs: { href: "#" },
              on: { click: _vm.addConnectionClick }
            },
            [
              _c("i", { staticClass: "fas fa-bullseye" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource(
                      "JourneyBuilder_JourneyBrickMenu_AddRoute_DisplayName"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              class: [_vm.canClickSettings ? "" : "disabled"],
              attrs: { href: "#" },
              on: { click: _vm.settingsClick }
            },
            [
              _c("i", { staticClass: "fas fa-cog" }),
              _vm._v(
                _vm._s(
                  _vm.resource(
                    "JourneyBuilder_JourneyBrickMenu_Settings_DisplayName"
                  )
                ) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dropdown-item",
              class: [_vm.canClickDelete ? "" : "disabled"],
              attrs: { href: "#" },
              on: { click: _vm.deleteClick }
            },
            [
              _c("i", { staticClass: "fas fa-trash" }),
              _vm._v(
                _vm._s(
                  _vm.resource(
                    "JourneyBuilder_JourneyBrickMenu_Remove_DisplayName"
                  )
                ) + "\n        "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }